import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=005b5cea&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=005b5cea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005b5cea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005b5cea')) {
      api.createRecord('005b5cea', component.options)
    } else {
      api.reload('005b5cea', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=005b5cea&scoped=true&", function () {
      api.rerender('005b5cea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20RYvcIVcSRAK/JS/comp/GuestBox.vue"
export default component.exports